import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import styled from 'styled-components'

const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  background-color: #000000;
  position: relative;
`;

const StyledImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  border: 2px solid #ccc;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

const TextOverlay = styled.div`
  position: absolute;
  bottom: 10%;
  left: 50%;
  transform: translateX(-50%);
  font-size: 16px;
  color: white;
  text-align: center;
  font-weight: bold;

  @media (min-width: 768px) {
    font-size: 18px;
  }
`;

const ErrorMessage = styled.p`
  color: red;
  font-size: 18px;
  text-align: center;
`;

const ImageViewer: React.FC = () => {
  const params = useParams<{ id: string; hash: string }>();
  const location = useLocation();
  const [imageBlobUrl, setImageBlobUrl] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  console.log('params:', params);
  console.log('location:', location);

  useEffect(() => {
    console.log('params:', params);

    // Captura os parâmetros da query string e do path
    const queryParams = new URLSearchParams(location.search);
    const queryId = queryParams.get('id');
    const queryHash = queryParams.get('hash');

    console.log('queryParams:', queryParams);
    console.log('queryId:', queryId);
    console.log('queryHash:', queryHash);

    // Prioriza a query string se estiver presente, caso contrário usa os parâmetros do path
    const id = queryId || params.id;
    const hash = queryHash || params.hash;

    if (!id || !hash) {
      setError('Parâmetros inválidos. Certifique-se de fornecer o ID e o hash.');
      return;
    }

    // Faz a requisição para buscar a imagem
    const fetchImage = async () => {
      try {
        const response = await axios.get(
          `https://quantictechnology.com.br/api/v1/prizedraw/secure-image/${id}/${hash}`,
          {
            responseType: 'blob', // Define o tipo da resposta como blob
          }
        );

        // Cria uma URL para o blob recebido
        const blobUrl = URL.createObjectURL(response.data);
        setImageBlobUrl(blobUrl);
      } catch (err) {
        console.error('Erro ao buscar a imagem:', err);
        setError('Sorteio inválido ou já finalizado.');
      }
    };

    fetchImage();
  }, [params, location]);

  return (
    <ImageWrapper>
      {error ? (
        <ErrorMessage>{error}</ErrorMessage>
      ) : imageBlobUrl ? (
        <>
          <StyledImage src={imageBlobUrl} alt="Prêmio" />
          <TextOverlay>Nº {params.id || new URLSearchParams(location.search).get('id')}</TextOverlay>
        </>
      ) : (
        <p>Carregando imagem...</p>
      )}
    </ImageWrapper>
  );
};

export default ImageViewer;
